import React from "react";
import Orders from "../modules/Orders/Orders";

export default function OrdersPage() {
  return <Orders />;
}
